module.exports = __webpack_public_path__ + "img/2.ecc04d0b.svg";